let url = window.location.pathname;
console.log("dynamicUrl:" + url);
const myUrl = url.split("/");

//获取路由中产业学院的参数 例如 feature-tdgc
// 因为pathname  最少是 由 '/' 组成的  并且是/后面的内容 所以  取数组第二个字段一定是产业学院的 路由
const params = myUrl[1];
const themeList = [
  {
    param: "feature-gslc",
    name: "高速列车产业学院",
    children: [
      // 主色调
      {
        propety: "--primary-color",
        color: "#4550EE"
      },
      {
        propety: "--register-color",
        color: "#2BE3BD"
      },
      // 渐变色调
      {
        propety: "--transition-primary-color",
        color: "#4971F1"
      },
      // 产业学院最上面的header 颜色
      {
        propety: "--header-color",
        color: "#4550EE"
      },
      // header 中字体颜色
      {
        propety: "--header-font-color",
        color: "#ffffff"
      },
      // 导航栏背景色
      {
        propety: "--header-nav-color",
        color: "#ffffff"
      },
      // 导航栏字体颜色
      {
        propety: "--header-navfont-color",
        color: "#333333"
      },
      // 导航栏 选中背景颜色
      {
        propety: "--header-nav-check-color",
        color: "#ffffff"
      },
      // 导航栏 选中时字体颜色
      {
        propety: "--header-navfont-check-color",
        color: "#4550EE"
      },
      // 导航栏选中线条颜色
      {
        propety: "--header-navbottom-check-color",
        color: "#ffffff"
      }
    ]
  },
  {
    param: "feature-bsd",
    name: "宝视达产业学院",
    children: [
      {
        propety: "--primary-color",
        color: "#5CC7CF"
      },
      {
        propety: "--register-color",
        color: "#5CC7CF"
      },
      {
        propety: "--header-color",
        color: "#ffffff"
      },
      {
        propety: "--transition-primary-color",
        color: "#8dd7dd"
      },
      {
        propety: "--header-font-color",
        color: "#333333"
      },
      // 导航栏背景色
      {
        propety: "--header-nav-color",
        color: "#5CC7CF"
      },
      // 导航栏字体颜色
      {
        propety: "--header-navfont-color",
        color: "#ffffff"
      },
      // 导航栏 选中背景颜色
      {
        propety: "--header-nav-check-color",
        color: "#8dd7dd"
      },
      // 导航栏 选中时字体颜色
      {
        propety: "--header-navfont-check-color",
        color: "#ffffff"
      },
      // 导航栏选中线条颜色
      {
        propety: "--header-navbottom-check-color",
        color: "#8dd7dd"
      }
    ]
  },
  {
    param: "feature-hsjs",
    name: "华晟经世产业学院",
    children: [
      {
        propety: "--primary-color",
        color: "#3AADFF"
      },
      {
        propety: "--register-color",
        color: "#3AADFF"
      },
      {
        propety: "--header-color",
        color: "#ffffff"
      },
      {
        propety: "--transition-primary-color",
        color: "#75c5ff"
      },
      {
        propety: "--header-font-color",
        color: "#333333"
      },
      // 导航栏背景色
      {
        propety: "--header-nav-color",
        color: "#3AADFF"
      },
      // 导航栏字体颜色
      {
        propety: "--header-navfont-color",
        color: "#ffffff"
      },
      // 导航栏 选中背景颜色
      {
        propety: "--header-nav-check-color",
        color: "#75c5ff"
      },
      // 导航栏 选中时字体颜色
      {
        propety: "--header-navfont-check-color",
        color: "#ffffff"
      },
      // 导航栏选中线条颜色
      {
        propety: "--header-navbottom-check-color",
        color: "#75c5ff"
      }
    ]
  },
  {
    param: "feature-ylhl",
    name: "养老护理产业学院",
    children: [
      {
        propety: "--primary-color",
        color: "#F2AF50"
      },
      {
        propety: "--register-color",
        color: "#F2AF50"
      },
      {
        propety: "--header-color",
        color: "#ffffff"
      },
      {
        propety: "--transition-primary-color",
        color: "#FBE7CA"
      },
      {
        propety: "--header-font-color",
        color: "#333333"
      },
      // 导航栏背景色
      {
        propety: "--header-nav-color",
        color: "#ffffff"
      },
      // 导航栏字体颜色
      {
        propety: "--header-navfont-color",
        color: "#F2AF50"
      },
      // 导航栏 选中背景颜色
      {
        propety: "--header-nav-check-color",
        color: "#ffffff"
      },
      // 导航栏 选中时字体颜色
      {
        propety: "--header-navfont-check-color",
        color: "#F2AF50"
      },
      // 导航栏选中线条颜色
      {
        propety: "--header-navbottom-check-color",
        color: "#F2AF50"
      }
    ]
  },
  {
    param: "feature-znzz",
    name: "智能制造产业学院",
    children: [
      {
        propety: "--primary-color",
        color: "#3AADFF"
      },
      {
        propety: "--register-color",
        color: "#3AADFF"
      },
      {
        propety: "--header-color",
        color: "#ffffff"
      },
      {
        propety: "--transition-primary-color",
        color: "#a9d9fe"
      },
      {
        propety: "--header-font-color",
        color: "#333333"
      },
      // 导航栏背景色
      {
        propety: "--header-nav-color",
        color: "#3AADFF"
      },
      // 导航栏字体颜色
      {
        propety: "--header-navfont-color",
        color: "#ffffff"
      },
      // 导航栏 选中背景颜色
      {
        propety: "--header-nav-check-color",
        color: "#75c5ff"
      },
      // 导航栏 选中时字体颜色
      {
        propety: "--header-navfont-check-color",
        color: "#ffffff"
      },
      // 导航栏选中线条颜色
      {
        propety: "--header-navbottom-check-color",
        color: "#75c5ff"
      }
    ]
  },
  {
    param: "feature-gtzh",
    name: "高铁综合产业学院",
    children: [
      {
        propety: "--primary-color",
        color: "#4550EE"
      },
      {
        propety: "--register-color",
        color: "#2BE3BD"
      },
      {
        propety: "--header-color",
        color: "#4550EE"
      },
      {
        propety: "--transition-primary-color",
        color: "#4971F1"
      },
      {
        propety: "--header-font-color",
        color: "#ffffff"
      },
      // 导航栏背景色
      {
        propety: "--header-nav-color",
        color: "#ffffff"
      },
      // 导航栏字体颜色
      {
        propety: "--header-navfont-color",
        color: "#333333"
      },
      // 导航栏 选中背景颜色
      {
        propety: "--header-nav-check-color",
        color: "#ffffff"
      },
      // 导航栏 选中时字体颜色
      {
        propety: "--header-navfont-check-color",
        color: "#4550EE"
      },
      // 导航栏选中线条颜色
      {
        propety: "--header-navbottom-check-color",
        color: "#ffffff"
      }
    ]
  },

  {
    param: "feature-tdgc",
    name: "铁道工程产业学院",
    children: [
      {
        propety: "--primary-color",
        color: "#4550EE"
      },
      {
        propety: "--register-color",
        color: "#2BE3BD"
      },
      {
        propety: "--header-color",
        color: "#4550EE"
      },
      {
        propety: "--transition-primary-color",
        color: "#4971F1"
      },
      {
        propety: "--header-font-color",
        color: "#ffffff"
      },
      // 导航栏背景色
      {
        propety: "--header-nav-color",
        color: "#ffffff"
      },
      // 导航栏字体颜色
      {
        propety: "--header-navfont-color",
        color: "#333333"
      },
      // 导航栏 选中背景颜色
      {
        propety: "--header-nav-check-color",
        color: "#ffffff"
      },
      // 导航栏 选中时字体颜色
      {
        propety: "--header-navfont-check-color",
        color: "#4550EE"
      },
      // 导航栏选中线条颜色
      {
        propety: "--header-navbottom-check-color",
        color: "#ffffff"
      }
    ]
  },
  {
    param: "feature-tdjt",
    name: "铁道交通运营产业学院",
    children: [
      {
        propety: "--primary-color",
        color: "#4550EE"
      },
      {
        propety: "--register-color",
        color: "#2BE3BD"
      },
      {
        propety: "--header-color",
        color: "#4550EE"
      },
      {
        propety: "--transition-primary-color",
        color: "#4971F1"
      },
      {
        propety: "--header-font-color",
        color: "#ffffff"
      },
      // 导航栏背景色
      {
        propety: "--header-nav-color",
        color: "#ffffff"
      },
      // 导航栏字体颜色
      {
        propety: "--header-navfont-color",
        color: "#333333"
      },
      // 导航栏 选中背景颜色
      {
        propety: "--header-nav-check-color",
        color: "#ffffff"
      },
      // 导航栏 选中时字体颜色
      {
        propety: "--header-navfont-check-color",
        color: "#4550EE"
      },
      // 导航栏选中线条颜色
      {
        propety: "--header-navbottom-check-color",
        color: "#ffffff"
      }
    ]
  },
  {
    param: "feature-cgjt",
    name: "城轨交通产业学院",
    children: [
      {
        propety: "--primary-color",
        color: "#5CC7CF"
      },
      {
        propety: "--register-color",
        color: "#5CC7CF"
      },
      {
        propety: "--header-color",
        color: "#ffffff"
      },
      {
        propety: "--transition-primary-color",
        color: "#8dd7dd"
      },
      {
        propety: "--header-font-color",
        color: "#333333"
      },
      // 导航栏背景色
      {
        propety: "--header-nav-color",
        color: "#5CC7CF"
      },
      // 导航栏字体颜色
      {
        propety: "--header-navfont-color",
        color: "#ffffff"
      },
      // 导航栏 选中背景颜色
      {
        propety: "--header-nav-check-color",
        color: "#8dd7dd"
      },
      // 导航栏 选中时字体颜色
      {
        propety: "--header-navfont-check-color",
        color: "#ffffff"
      },
      // 导航栏选中线条颜色
      {
        propety: "--header-navbottom-check-color",
        color: "#8dd7dd"
      }
    ]
  }
];

themeList.forEach(item => {
  if (item.param === params) {
    document.title = item.name;
    item.children.forEach(tar => {
      document
        .getElementsByTagName("body")[0]
        .style.setProperty(tar.propety, tar.color);
    });
  }
});
